import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import HomePage from './pages/home/HomePage';
import SeriesPage from './pages/SeriesPage';
import SetsPage from './pages/SetsPage';
import SetCardsPage from './pages/SetCardsPage';
import Search from './pages/Search';
import SearchRedirect from './pages/SearchRedirect';
import Card from './pages/Card';
import ProductPage from './pages/ProductPage';
import SealedPage from './pages/SealedPage';
import TcgRedirect from './pages/TcgRedirect';
import AboutPage from './pages/info/AboutPage';
import ContactPage from './pages/info/ContactPage';
import PrivacyPage from './pages/info/PrivacyPage';
import LoginPage from './components/LoginPage';
import ProfilePage from './components/ProfilePage';
import EditProfilePage from './components/EditProfilePage';
import ProfileSetup from './components/ProfileSetup';
import AuthCallback from './components/AuthCallback';
import SettingsPage from './components/SettingsPage';
import Navbar from './components/Navbar';
import AppFooter from './components/layout/AppFooter';
import ServerPage from './pages/ServerPage';
import NotFoundPage from './pages/NotFoundPage';
import FeedbackWidget from './components/FeedbackWidget';
import analyticsService from './services/analyticsService';
import './index.css';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    analyticsService.initConsentManager();
    analyticsService.trackRouteChange(location.pathname, location.search);
  }, [location.pathname, location.search]);

  const hideChrome =
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/signup') ||
    location.pathname === '/profile-setup' ||
    location.pathname === '/auth/callback';
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen">
      {!hideChrome && <Navbar />}
      
      <main className={hideChrome ? '' : isHomePage ? '' : 'container mx-auto px-4 py-8'}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/series" element={<SeriesPage />} />
          <Route path="/series/:seriesId" element={<SetsPage />} />
          <Route path="/sets/:setId" element={<SetCardsPage />} />
          {/* WO-42: api-built pages (stores, rankings, methodology), lilycove-api services/seo_hubs.py */}
          <Route path="/sets/:setId/most-valuable" element={<ServerPage />} />
          <Route path="/stores" element={<ServerPage />} />
          <Route path="/stores/:province" element={<ServerPage />} />
          <Route path="/store/:storeId" element={<ServerPage />} />
          <Route path="/methodology" element={<ServerPage />} />
          <Route path="/search" element={<SearchRedirect />} />
          <Route path="/search/:query" element={<Search />} />
          <Route path="/card/:cardId" element={<Card />} />
          <Route path="/product/:productId" element={<ProductPage />} />
          <Route path="/sealed" element={<SealedPage />} />
          <Route path="/tcg/:tcgId" element={<TcgRedirect />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          {/* "/*": Clerk's SignIn/SignUp route their own steps (factor-one, sso-callback, ...) under these paths */}
          <Route path="/login/*" element={<LoginPage />} />
          <Route path="/signup/*" element={<LoginPage />} />
          <Route path="/profile/:username" element={<ProfilePage />} />
          <Route path="/edit-profile" element={<EditProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile-setup" element={<ProfileSetup />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!hideChrome && <AppFooter />}
      <FeedbackWidget />
    </div>
  );
}

function App() {
  return (
    // Router outermost: Clerk navigates with react-router (routerPush/routerReplace).
    <Router>
      <AuthProvider>
        <CurrencyProvider>
          <AppContent />
        </CurrencyProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
